// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplateItemDetailQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ItemTemplateItemDetailQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, name: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }> };

export type ItemTemplateItemDetailItemFragment = { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, name: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined };

export const ItemTemplateItemDetailItemFragmentDoc = gql`
    fragment ItemTemplateItemDetailItem on Item {
  id
  name: displayName
  costCode {
    id
    name
  }
  tradeCategory {
    id
    name
  }
}
    `;
export const ItemTemplateItemDetailDocument = gql`
    query ItemTemplateItemDetail {
  items(filter: {status: [ACTIVE]}) {
    ...ItemTemplateItemDetailItem
  }
  locations {
    id
    name
  }
  unitsOfMeasure {
    id
    name
    useQuantity
  }
}
    ${ItemTemplateItemDetailItemFragmentDoc}`;

/**
 * __useItemTemplateItemDetailQuery__
 *
 * To run a query within a React component, call `useItemTemplateItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateItemDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemTemplateItemDetailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>(ItemTemplateItemDetailDocument, options);
      }
export function useItemTemplateItemDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>(ItemTemplateItemDetailDocument, options);
        }
// @ts-ignore
export function useItemTemplateItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>;
export function useItemTemplateItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateItemDetailQuery | undefined, ItemTemplateItemDetailQueryVariables>;
export function useItemTemplateItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>(ItemTemplateItemDetailDocument, options);
        }
export type ItemTemplateItemDetailQueryHookResult = ReturnType<typeof useItemTemplateItemDetailQuery>;
export type ItemTemplateItemDetailLazyQueryHookResult = ReturnType<typeof useItemTemplateItemDetailLazyQuery>;
export type ItemTemplateItemDetailSuspenseQueryHookResult = ReturnType<typeof useItemTemplateItemDetailSuspenseQuery>;
export type ItemTemplateItemDetailQueryResult = ApolloReactCommon.QueryResult<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>;